// import 'fullcalendar-reactwrapper/dist/css/fullcalendar.min.css'
import { createBrowserHistory } from 'history'
import 'rc-time-picker/assets/index.css'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import 'semantic-ui-css/semantic.min.css'

import Main from './components'
import { setLanguage } from './helpers/languages'
import { bindUnauthorised } from './helpers/requests'
import createStore from './store'
import { actions as misc } from './store/actions/misc'
import './assets/css/index.css'
import cookie from 'react-cookies'

// Build the history.
const history = createBrowserHistory()

// Build the store.
const store = createStore({}, history)

// Set the language.
setLanguage(cookie.load('language') ? cookie.load('language') : store.getState().settings.language)

// Determine what should happen in case of unauthorised requests.
bindUnauthorised(() => {
    store.dispatch(misc.wipeOut())
})

const render = () => {
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Main/>
            </ConnectedRouter>
        </Provider>
    )
}
const feel = document.getElementById('feel')
ReactDOM.render(render(), feel)



// WEBPACK FOOTER //
// ./src/index.js